<template>
  <!-- <div class="btn" @click="goApplets">打开COTTI小程序</div> -->
</template>

<script>
import wx from "weixin-js-sdk";
export default {
  name: "orderdetail",
  data() {
    return {};
  },
  created() {
    var orderId = this.getUrlParam("orderId").replace("/", "");
    console.log(
      `/packages/order/order-detail/index?orderId=${orderId}`,
      "==========订单id"
    );
    if (orderId.includes('App')) {
      /// APP内跳转,app端orderId后拼接 App 用于标识来源
      orderId = orderId.replace('App', '');
      console.log('in app orderId = ', orderId);
      /// webBack 为通知App中webview调用goBack()，防止该订单详情的空白页面出现
      const data = `{"path":"cotti://coffee/pages/tabs/order/order_detail?orderNo=${orderId}","webBack":"webBack"}`;
      CottiNavigation.postMessage(data);
      
    } else { 
      /// 小程序跳转
      wx.miniProgram.navigateTo({
      url: `/packages/order/order-detail/index?orderId=${orderId}`,
    });
    }
  },
  methods: {
    getUrlParam(name) {
      // 给定URL参数名称取得对应的参数
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      if (reg.test(location.search.substr(1))) {
        return decodeURIComponent(RegExp.$2);
      } else if (
        reg.test(location.hash.substr(location.hash.indexOf("?") + 1))
      ) {
        return decodeURIComponent(RegExp.$2);
      } else {
        return "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.btn {
  width: 336px;
  height: 80px;
  background: #fc4c02;
  border-radius: 2px;
  text-align: center;
  font-size: 28px;
  font-weight: 500;
  color: #ffffff;
  line-height: 80px;
  margin: 0 auto;
  margin-top: 50%;
}
</style>